package org.hs_soft.runmynesto.domain.util

import kotlinx.browser.window


object ApiUtils
{
    object Domain{
        const val s3Domain="runmyresto-web.s3-website-eu-west-1.amazonaws.com"
        const val baseDomain="https://oriecabyn24ma7nqnuzhkzcqgq0tjmfn.lambda-url.us-east-1.on.aws/"
        const val dataAssistantDomain="https://vcx6elk2qwqcirl7myd2ocdyre0fghhj.lambda-url.eu-west-1.on.aws/"
        const val console="console.hssoft.com"
        const val consoleRMR="console.runmyresto.ch"
        const val localhost="localhost"
        const val localhost127="127.0.0.1"
    }
    object API_KEY{
      const val RESTAURANTS_API_KEY_VALUE = "734e4c9f9fefcc645259a6d54a014680"
    }

    object DATA_ASSISTANT {
        const val name = "RestoMate"
        const val testEmail = "rleiderman@hssoft.com"
    }


    object Type{
        const val updateMediaCashRegisters="updateMedia_cashRegisters"
        const val user="User"
        const val Media9_16="Media9_16"
        const val Media="Media"
    }

    object CURRENCY_TYPE{
        const val CHF="CHF"
        const val EUR="EUR"
    }
    object Status{
        const val ERR_401="401"
    }


    object Cognito {

        private val isDev =// false
            window.location.hostname.contains(ApiUtils.Domain.localhost)
                ||window.location.hostname.contains(ApiUtils.Domain.localhost127)
                    || window.location.hostname.contains(ApiUtils.Domain.s3Domain)


        private object Dev {
            const val API_URL = "https://devapi.hssoft.com/graphql"
            const val KOTLIN_API_URL="https://web.api.runmyresto.com/dev/graphql"
            const val USER_POOL_ID = "eu-west-1_HB2RoWYWY"
            const val USER_POOL_CLIENT_ID = "v5ev0902vd0m0gcdb551hu37h"
            const val IDENTITY_POOL_ID = "eu-west-1:d901e32d-9604-4851-9907-acd611a558c8"
            const val REGION = "eu-west-1"
            const val BUCKET = "cashassist-api-dev-uploads"
            const val Domain = ".hssoft.com"

        }


        private object Prod {
            const val API_URL = "https://api.hssoft.com/graphql"
            const val KOTLIN_API_URL="https://web.api.runmyresto.com/prod/graphql"
            const val USER_POOL_ID = "eu-west-1_ZQAKufUVZ"
            const val USER_POOL_CLIENT_ID = "1t2j35i84uj8ekvr29np02n9k7"
            const val IDENTITY_POOL_ID = "eu-west-1:46ef19b7-823a-4c10-a0a6-fa23d303688e"
            const val REGION = "eu-west-1"
            const val BUCKET = "upload.cashassist.hssoft.com"
            const val Domain = ".hssoft.com"


        }
        val KOTLIN_API_URL get() = if (isDev) Dev.KOTLIN_API_URL
            else Prod.KOTLIN_API_URL
        val API_URL get() = if (isDev) Dev.API_URL
            else Prod.API_URL
        val USER_POOL_ID get() = if (isDev) Dev.USER_POOL_ID
             else Prod.USER_POOL_ID
        val USER_POOL_CLIENT_ID get() = if (isDev) Dev.USER_POOL_CLIENT_ID
             else Prod.USER_POOL_CLIENT_ID
        val IDENTITY_POOL_ID get() = if (isDev) Dev.IDENTITY_POOL_ID
            else Prod.IDENTITY_POOL_ID
        val REGION get() = if (isDev) Dev.REGION else Prod.REGION
        val BUCKET get() = if (isDev) Dev.BUCKET else Prod.BUCKET
        val Domain get() = if (isDev) Dev.Domain else Prod.Domain
    }


    object Field {
        const val articlePriceCategory="articlePriceCategory"
        const val minQuantity = "minQuantity"
        const val maxQuantity = "maxQuantity"
        const val isCollectPoints = "isCollectPoints"
        const val course = "course"
        const val setsMode = "setsMode"
        const val priceDiffMode = "priceDiffMode"
        const val printChosenSubProductsFlag = "printChosenSubProductsFlag"
        const val fixProductsAutoSelect = "fixProductsAutoSelect"
        const val isPricesNormalByDefaultInSet = "isPricesNormalByDefaultInSet"
        const val isFastSelection = "isFastSelection"
        const val isForTasting = "isForTasting"
        const val printChosenSubProducts = "printChosenSubProducts"
        const val isMenuName="isMenuName"
        const val fullDiscount="fullDiscount"
        const val actionGroup="actionGroup"
        const val actionDiscount="actionDiscount"
        const val less="less"
        const val more="more"
        const val toDate="toDate"
        const val fromDate="fromDate"
        const val typeName="typeName"
        const val dimensions="dimensions"
        const val sortId="sortId"
        const val specialPrices="specialPrices"
        const val walleeTerminalID="walleeTerminalID"
        const val walleeSpaceId="walleeSpaceId"
        const val walleeUserId="walleeUserId"
        const val walleeVirtualTerminalId="walleeVirtualTerminalId"
        const val walleeApplicationKey="walleeApplicationKey"
        const val hsPayStore="hsPayStore"
        const val creditPositionInfo="creditPositionInfo"
        const val adyenPoiId="adyenPoiId"
        const val adyenLiveEndpointUrlPrefix="adyenLiveEndpointUrlPrefix"
        const val adyenApiKey="adyenApiKey"
        const val paymentTerminal="paymentTerminal"

        const val isPrintEFTReceipts="isPrintEFTReceipts"

        const val date="date"
        const val SUNMI_CLOUD_PRINTER="SUNMI_CLOUD_PRINTER"
        const val port="port"
        const val posId="posId"
        const val serialNumber="serialNumber"
        const val tseIsActive="tseIsActive"
        const val propertyId="propertyId"
        const val salesGroupIds="salesGroupIds"
        const val updateAppConfig="updateAppConfig"
        const val cashRegisterGlobal="cashRegisterGlobal"
        const val apaleaoClientId="apaleaoClientId"
        const val apaleaoClientSecret="apaleaoClientSecret"
        const val creditCardIndexArr="creditCardIndexArr"
        const val departmentId="departmentId"
        const val dateInterval="dateInterval"
        const val tableNumber="tableNumber"
        const val totalRevenue="totalRevenue"
        const val revenueChangePct="revenueChangePct"
        const val floorId="floorId"
        const val objectType = "objectType"
        const val caption = "caption"
        const val modVer = "mod_ver"
        const val floors = "floors"
        const val projectId = "projectId"
        const val rooms = "rooms"
        const val roomColor = "roomColor"
        const val furniture = "furniture"
        const val roomId = "roomId"
        const val objectKind = "objectKind"
        const val componentColor = "componentColor"
        const val positionTop = "positionTop"
        const val positionLeft = "positionLeft"
        const val rotationDeg = "rotationDeg"
        const val height = "height"
        const val width = "width"
        const val shape = "shape"
        const val updateMediaMain="updateMedia_Main"
        const val productsId="productsId"
        const val label="label"
        const val codePrefix="codePrefix"
        const val timeInterval="timeInterval"
        const val animationType="animationType"
        const val stayActive="stayActive"
        const val tagId="tagId"
        const val refreshTime="refreshTime"
        const val fromTime="fromTime"
        const val expectedUrl="expectedUrl"
        const val cacheKey="cacheKey"
        const val shopName="shopName"
        const val salesGroup = "salesGroup"
        const val number = "number"
        const val group1 = "group1"
        const val group2 = "group2"
        const val group3 = "group3"
        const val weight = "weight"
        const val creditCustomerTotal = "creditCustomerTotal"
        const val creditCustomer = "creditCustomer"
        const val creditCustomerWeight = "creditCustomerWeight"
        const val order1 = "order1"
        const val order1Amount = "order1Amount"
        const val unsold = "unsold"
        const val unsoldAmount = "unsoldAmount"
        const val unsoldPercent = "unsoldPercent"
        const val deliver = "deliver"
        const val stock = "stock"
        const val stockAmount = "stockAmount"
        const val oldStock = "oldStock"
        const val differenceAmount = "differenceAmount"
        const val billAmount1 = "billAmount1"
        const val billAmount2 = "billAmount2"
        const val billAmount3 = "billAmount3"
        const val billAmount4 = "billAmount4"
        const val onlyThis = "onlyThis"
        const val firstSale = "firstSale"
        const val lastSale = "lastSale"
        const val inCafeNumber = "inCafeNumber"
        const val inCafeTotal = "inCafeTotal"
        const val promotionNumber = "promotionNumber"
        const val promotionTotal = "promotionTotal"
        const val breakfastNumber = "breakfastNumber"
        const val breakfastTotal = "breakfastTotal"
        const val discountNumber = "discountNumber"
        const val discountTotal = "discountTotal"
        const val g1Percent = "g1Percent"
        const val g1PercentT = "g1PercentT"
        const val g1Abc = "g1Abc"
        const val gNumber = "gNumber"
        const val grossProfit = "grossProfit"
        const val contributionMargin = "contributionMargin"
        const val cardName = "cardName"
        const val cardNumber = "cardNumber"
        const val cashRegisterName = "cashRegisterName"
        const val cancellationUserName = "cancellationUserName"
        const val loyaltycardId = "loyaltycardId"
        const val timer = "timer"
        const val cancellationUserId = "cancellationUserId"
        const val totalWithoutCancellation = "totalWithoutCancellation"
        const val discountPercent = "discountPercent"
        const val flag = "flag"
        const val mul1 = "mul1"
        const val product = "product"
        const val periodStart = "periodStart"
        const val periodEnd = "periodEnd"
        const val cashRegisterIds = "cashRegisterIds"
        const val timeCheck = "timeCheck"
        const val interval = "interval"
        const val getCustomerFrequencies = "getCustomerFrequencies"
        const val timeStart = "timeStart"
        const val timeEnd = "timeEnd"
        const val CustomerFrequenciesFragment = "CustomerFrequenciesFragment"
        const val CustomerFrequencies = "CustomerFrequencies"
        const val billCount = "billCount"
        const val totalK = "totalK"
        const val creditClientCount = "creditClientCount"
        const val creditClientTotal = "creditClientTotal"

        const val clientTree = "clientTree"
        const val regions = "regions"
        const val shops = "shops"
        const val typename = "__typename"
        const val listShops = "listShops"
        const val items = "items"
        const val regionId = "regionId"
        const val cashRegisters = "cashRegisters"
        const val isAvailableInWebApp = "isAvailableInWebApp"
        const val getAppConfig = "getAppConfig"
        const val getDashboardDSGeo = "getDashboardDSGeo"
        const val coordinates = "coordinates"
        const val googleMapUrl = "google_map_url"

        const val requestId = "requestId"
        const val request_id = "request_id"
        const val cashAssist = "cashAssist"
        const val getStatisticsData = "getStatisticsData"
        const val status = "status"
        const val progress = "progress"
        const val CustomerStatisticShopFragment = "CustomerStatisticShopFragment"
        const val StatisticShop = "StatisticShop"
        const val closingData = "closingData"
        const val cashDifference = "cashDifference"
        const val totalPerBill = "totalPerBill"
        const val customerCount = "customerCount"
        const val realHours = "realHours"
        const val totalPerRealTimeHours = "totalPerRealTimeHours"
        const val clientCount = "clientCount"
        const val productCount = "productCount"
        const val cancellationsCount = "cancellationsCount"
        const val clientCardValue = "clientCardValue"
        const val billNumStart = "billNumStart"
        const val billNumEnd = "billNumEnd"
        const val moneyCountDateTime = "moneyCountDateTime"
        const val doorCounter = "doorCounter"
        const val guestsCount = "guestsCount"
        const val inactive = "inactive"
        const val inactiveDate = "inactiveDate"
        const val inactiveReason = "inactiveReason"
        const val inactiveUserId = "inactiveUserId"
        const val mWStNormal = "mWStNormal"
        const val mWStReduced = "mWStReduced"
        const val mWStFree = "mWStFree"
        const val mWStSpecial = "mWStSpecial"
        const val reduction = "reduction"
        const val present = "present"
        const val exchangeRate = "exchangeRate"
        const val presentConverted = "presentConverted"
        const val difference = "difference"
        const val cashInTransit = "cashInTransit"
        const val amountConverted = "amountConverted"
        const val MWSt = "MWSt"
        const val sales = "sales"
        const val count = "count"
        const val have = "have"
        const val should = "should"
        const val averageBill = "averageBill"
        const val userEfficiency = "userEfficiency"
        const val cancellationsAmount = "cancellationsAmount"
        const val buttonOpenCount = "buttonOpenCount"
        const val buttonBackCount = "buttonBackCount"
        const val buttonDelCount = "buttonDelCount"
        const val buttonDelAmount = "buttonDelAmount"
        const val inCafeCount = "inCafeCount"
        const val inCafeAmount = "inCafeAmount"
        const val inCafePercent = "inCafePercent"
        const val quantity = "quantity"
        const val invoiceId = "invoiceId"

        const val totalAmount = "totalAmount"
        const val clientNumber="clientNumber"
        const val lastUpdatedAt = "lastUpdatedAt"
        const val isPointsActive = "isPointsActive"
        const val limit = "limit"
        const val dayLimit = "dayLimit"
        const val clientName = "clientName"
        const val clientSurname = "clientSurname"
        const val salutation = "salutation"
        const val additive = "additive"
        const val isUser = "isUser"
        const val userId = "userId"
        const val userIdToken = "user_id_token"
        const val user = "user"
        const val postcode = "postcode"
        const val validPhoneNumber = "validPhoneNumber"
        const val email = "email"
        const val creditClientId = "creditClientId"
        const val creditClient = "creditClient"
        const val freePercent = "freePercent"
        const val masterPercent = "masterPercent"
        const val numberOfPercent = "numberOfPercent"
        const val balanceDiscount = "balanceDiscount"
        const val alwaysDiscount = "alwaysDiscount"
        const val cashLoad = "cashLoad"
        const val balancePoints = "balancePoints"
        const val statusVirtual = "statusVirtual"
        const val accessCode = "accessCode"
        const val rfid = "rfid"
        const val virtualCardLink = "virtualCardLink"
        const val phoneNumber="phoneNumber"
        const val barCode="barCode"
        const val total="total"
        const val type="type"
        const val points="points"
        const val balance="balance"
        const val topMargin="topMargin"
        const val ip="ip"
        const val ipDeviceLabel="ipDeviceLabel"
        const val tableShiftReceipt="tableShiftReceipt"
        const val copyForWaiter="copyForWaiter"
        const val isPrintKitchenBillForTableOnly="isPrintKitchenBillForTableOnly"
        const val isPrintKitchenBillAfterCompletionOnly="isPrintKitchenBillAfterCompletionOnly"
        const val printer="printer"
        const val isKitchenPrinterActive="isKitchenPrinterActive"
        const val mode="mode"
        const val isPiecemeal="isPiecemeal"
        const val priceLevelIn="priceLevelIn"
        const val priceLevelOut="priceLevelOut"
        const val SIZE="size"
        const val FONT_NAME="fontName"
        const val VALUE="value"
        // Cash Register fields
        const val INSTALL_VERSION = "installVersion"
        const val IS_SYNCED = "isSynced"
        const val STATUS = "status"
        const val DEVICE_IDENTITY = "deviceIdentity"
        const val HARDWARE_ID = "hardwareId"
        const val CLIENT_TYPE = "clientType"
        const val ELOVIEW_ID = "eloviewId"
        const val TSE_REMOTE_CASH_REGISTER_ID = "tseRemoteCashRegisterId"
        const val TSE_INFO = "tseInfo"
        const val INFO = "info"
        const val EXPIRATION_DATE = "expirationDate"



        const val separateKitchenBill = "separateKitchenBill"
        const val TOP_MARGIN = "topMargin"
        const val DEFAULT_LABEL_ID = "defaultLabelID"
        const val AUTOMATIC_LABEL_PRINT = "automaticLabelPrint"
        const val IS_KITCHEN_PRINTER_ACTIVE = "isKitchenPrinterActive"
        const val IS_PRINT_KITCHEN_BILL_AFTER_COMPLETION_ONLY = "isPrintKitchenBillAfterCompletionOnly"
        const val IS_PRINT_KITCHEN_BILL_FOR_TABLE_ONLY = "isPrintKitchenBillForTableOnly"
        const val LOCATIONS = "locations"
        const val POSITION = "position"
        const val IS_ACTIVE = "isActive"
        const val IS_DIRECT_CONNECTED = "isDirectConnected"
        const val IP_DEVICE_LABEL = "ipDeviceLabel"
        const val COPY_FOR_WAITER = "copyForWaiter"
        const val TABLE_SHIFT_RECEIPT = "tableShiftReceipt"

        // Payment terminal fields
        const val PAYMENT_TERMINAL = "paymentTerminal"
        const val ID = "id"
        const val SERIAL_NUMBER = "serialNumber"
        const val POS_ID = "posId"
        const val PORT = "port"
        const val SUM_UP_EMAIL = "sumUpEmail"
        const val SUM_UP_PASSWORD = "sumUpPassword"
        const val CREDIT_POSITION_INFO = "creditPositionInfo"
        const val WALLEE_APPLICATION_KEY = "walleeApplicationKey"
        const val WALLEE_VIRTUAL_TERMINAL_ID = "walleeVirtualTerminalId"
        const val WALLEE_USER_ID = "walleeUserId"
        const val WALLEE_SPACE_ID = "walleeSpaceId"
        const val WALLEE_TERMINAL_ID = "walleeTerminalID"

        // Additional fields
        const val BUILT_IN_FONTS = "builtInFonts"
        const val LOCAL_IP_ADDRESS = "localIPAddress"
        const val HAS_BARCODE_BY_RECEIPT_TOTAL = "hasBarcodeByReceiptTotal"
        const val GLORY_TERMINAL_CONNECTED = "gloryTerminalConnected"
        const val GLORY_TERMINAL_ADDRESS = "gloryTerminalAddress"
        const val GLORY_TERMINAL_USER = "gloryTerminalUser"
        const val GLORY_TERMINAL_PASSWORD = "gloryTerminalPassword"
        const val CATEGORY_FONT = "categoryFont"
        const val PRODUCT_FONT = "productFont"
        const val AUTO_CLOSE_BILL = "autoCloseBill"
        const val AUTO_SELECT_FIRST_CATEGORY = "autoSelectFirstCategory"
        const val CATEGORY_GRID_X = "categoryGridX"
        const val CATEGORY_GRID_Y = "categoryGridY"
        const val SPECIAL_DESIGN_TYPE = "specialDesignType"
        const val CARD_TEXT_COLOR = "cardTextColor"
        const val IS_MAIN_SCREEN_WITH_VIDEO = "isMainScreenWithVideo"
        const val ACCENT_COLOR = "accentColor"
        const val TEXT_COLOR = "textColor"
        const val BACKGROUND_COLOR = "backgroundColor"
        const val HAS_FAST_LINE = "hasFastLine"
        const val MULTI_LANGUAGE = "multiLanguage"
        const val MAIN_SCREEN_LOGO = "mainScreenLogo"
        const val PAYMENT_BACKGROUND_IMG = "paymentBackgroundImg"
        const val LOYALTY_CARD_IMG = "loyaltyCardImg"
        const val LOYALTY_CARD_ICON = "loyaltyCardIcon"
        const val TAKE_OUT_IMG = "takeOutImg"
        const val IN_CAFE_IMG = "inCafeImg"
        const val SETTINGS_PASSWORD = "settingsPassword"
        const val SHOW_ORDER_VIEW_KIOSK = "showOrderViewKiosk"
        const val USE_OLD_DESIGN = "useOldDesign"
        const val LOGO = "logo"
        const val IMG = "img"
        const val UID = "uid"
        const val KEY = "key"
        const val DISALLOW_LOYALTY_CARDS = "disallowLoyaltyCards"
        const val CLOSING_TIME = "closingTime"
        const val DISPLAY_EITHER_CATEGORIES_OR_PRODUCTS = "displayEitherCategoriesOrProducts"
        const val IDLE_MINUTES_BEFORE_LOCK = "idleMinutesBeforeLock"
        const val DISPLAY_ARTICLE = "displayArticle"
        const val SCALE = "scale"
        const val SCALE_DISPLAY_ALWAYS_VISIBLE = "scaleDisplayAlwaysVisible"
        const val IS_QR_CODE_BILL_ENABLED = "isQRCodeBillEnabled"
        const val WEIGHT_TARA = "weightTara"
        const val NAMES = "names"
        const val VALUES = "values"
        const val IS_AUTO_SELECT = "isAutoSelect"
        const val TSE_IS_ACTIVE = "tseIsActive"
        const val TSE_TYPE = "tseType"
        const val TSE_ADMIN_PIN = "tseAdminPin"
        const val TSE_ADMIN_PUK = "tseAdminPuk"
        const val TSE_TIME_ADMIN_PIN = "tseTimeAdminPin"
        const val TSE_TIME_ADMIN_PUK = "tseTimeAdminPuk"
        const val TSE_EPSON_IP = "tseEpsonIp"
        const val TSE_PRINT_QR_CODE = "tsePrintQRCode"
        const val IS_CASHIER_HAS_MANY_DRAWERS = "isCashierHasManyDrawers"

        const val dateTime = "dateTime"
        const val groupId = "groupId"
        const val billNumber = "billNumber"
        const val user_name = "user_name"
        const val user_email = "user_email"
        const val user_company_name = "user_company_name"
        const val userName = "userName"
        const val increase = "increase"
        const val decrease = "decrease"
        const val pointsTotal = "pointsTotal"
        const val transactionDate = "transactionDate"
        const val isCancelled = "isCancelled"
        const val isActivePointsSystem="isActivePointsSystem"
        const val pointsSystemName="pointsSystemName"
        const val TYPENAME = "__typename"
        const val standardWithoutPrinting="standardWithoutPrinting"
        const val withCashReportAndCountProtocol="withCashReportAndCountProtocol"
        const val withoutCash="withoutCash"
        const val standard="standard"
        const val withCashReport="withCashReport"
        const val receiptCopies="receiptCopies"
        const val startPiecemeal="startPiecemeal"
        const val clientButtonName="clientButtonName"
        const val button1 = "button1"
        const val buttonName1 = "buttonName1"
        const val button2 = "button2"
        const val buttonName2 = "buttonName2"
        const val button3 = "button3"
        const val buttonName3 = "buttonName3"
        const val button4 = "button4"
        const val buttonName4 = "buttonName4"
        const val button5 = "button5"
        const val buttonName5 = "buttonName5"
        const val to = "to"
        const val normal = "normal"
        const val inCafe = "inCafe"
        const val roundTo = "roundTo"
        const val changeTo = "changeTo"
        const val exchangeRateIsUsed = "exchangeRateIsUsed"
        const val additionPercent = "additionPercent"
        const val isEuroCoinsNotShown = "isEuroCoinsNotShown"
        const val is200EuroNotShown = "is200EuroNotShown"
        const val isShowTotalEuroOnCustomerDisplay = "isShowTotalEuroOnCustomerDisplay"
        const val isDefinedMannualy = "isDefinedMannualy"
        const val foreignCurrency="foreignCurrency"
        const val priceLevelForm="priceLevelForm"
        const val discountForm="discountForm"
        const val reducedVat = "reducedVat"
        const val normalVat = "normalVat"
        const val specialVat = "specialVat"
        const val isInCafeModeInt = "isInCafeModeInt"
        const val isInCafeMode = "isInCafeMode"
        const val isInCafeModeDefault = "isInCafeModeDefault"
        const val isActiveTimeAssist = "isActiveTimeAssist"
        const val loginOnlyAfterTimeRecording = "loginOnlyAfterTimeRecording"
        const val logoutOnlyAfterTimeRecording = "logoutOnlyAfterTimeRecording"
        const val apaleoPmsProperty = "apaleoPmsProperty"
        const val pmsType = "pmsType"
        const val pmsProtelIP = "pmsProtelIP"
        const val pmsProtelPort = "pmsProtelPort"
        const val nonGuestTransfer = "nonGuestTransfer"
        const val pmsAutoPrintBills = "pmsAutoPrintBills"
        const val isDiscountFormDisabled = "isDiscountFormDisabled"
        const val drawerCloseCheck = "drawerCloseCheck"
        const val hideOpenDrawerBtn = "hideOpenDrawerBtn"
        const val isDrawerOpenDuringClosing = "isDrawerOpenDuringClosing"
        const val isReturnButtonDeleted = "isReturnButtonDeleted"
        const val designProject = "designProject"
        const val restaurantIsMainMode = "restaurantIsMainMode"
        const val restaurantDefaultRoom = "restaurantDefaultRoom"
        const val restaurantBirdViewActive = "restaurantBirdViewActive"
        const val isHospitalityReceiptEnabled = "isHospitalityReceiptEnabled"
        const val isInCafeConfirmationBeforePayment = "isInCafeConfirmationBeforePayment"
        const val serviceCallMode = "serviceCallMode"
        const val retrieveNumberOfGuests = "retrieveNumberOfGuests"
        const val closingType = "closingType"
        const val isEmployeeClosingActive = "isEmployeeClosingActive"
        const val isSellProductInWorkingTime = "isSellProductInWorkingTime"
        const val itemLoyaltyCard = "itemLoyaltyCard"
        const val activateTipFunction = "activateTipFunction"
        const val egumaCreditId = "egumaCreditId"
        const val isEgumaActive = "isEgumaActive"
        const val guradoCreditId = "guradoCreditId"
        const val isGuradoActive = "isGuradoActive"
        const val preoderPrepaidProduct = "preoderPrepaidProduct"
        const val preoderPickupProduct = "preoderPickupProduct"
        const val revolutPaymentDiscount="revolutPaymentDiscount"
        const val isRevolutPaymentActive="isRevolutPaymentActive"
        const val e2nIntegrationActive="e2nIntegrationActive"
        const val e2nReportingActive="e2nReportingActive"
        const val portosIntegrationKey="portosIntegrationKey"
        const val isShopFieldActive="isShopFieldActive"
        const val mainCurrency="mainCurrency"
        const val specialProductExpenses="specialProductExpenses"
        const val creditCards="creditCards"
        const val classSuffix = "classSuffix"
        const val issuerName = "issuerName"
        const val issuerEmail = "issuerEmail"
        const val programName = "programName"
        const val accountIdLabel = "accountIdLabel"
        const val rewardsTierLabel = "rewardsTierLabel"
        const val rewardsTier = "rewardsTier"
        const val secondaryRewardsTierLabel = "secondaryRewardsTierLabel"
        const val secondaryRewardsTier = "secondaryRewardsTier"
        const val logoImg = "logoImg"
        const val wideLogoImg = "wideLogoImg"
        const val wideLogoGoogleImg = "wideLogoGoogleImg"
        const val heroGoogleImg = "heroGoogleImg"
        const val backgroundColor = "backgroundColor"
        const val foregroundColor = "foregroundColor"
        const val labelColor = "labelColor"
        const val homepageUri = "homepageUri"
        const val linkPhoneUri = "linkPhoneUri"
        const val isDefault = "isDefault"
        const val link = "link"

        const val additions="additions"
        const val accountingZeroPercent="accountingZeroPercent"
        const val accountingNormal="accountingNormal"
        const val accountingReduced="accountingReduced"
        const val discount="discount"
        const val percent="percent"
        const val variants="variants"
        const val productId="productId"
        const val after: String="after"
        const val before: String="before"
        const val hasPrevious: String="hasPrevious"
        const val hasNext: String="hasNext"
        const val amount="amount"
        const val keyword: String="keyword"
        const val ingredientId="ingredientId"
        const val contains="contains"
        const val img="img"
        const val countryId: String="countryId"
        const val description="description"
        const val question="question"
        const val assistant="assistant"
        const val companyId="company_id"
        const val data="data"
        const val chatId="chat_id"
        const val files="files"
        const val weekDays="weekDays"
        const val color="color"
        const val validAfter="validAfter"
        const val surchargePercent:String="surchargePercent"
        const val surchargeFrom: String="surchargeFrom"
        const val surchargeAmount: String="surchargeAmount"
        const val priceLevels: String="priceLevels"
        const val units: String="units"
        const val group: String="group"
        const val uuid: String="uuid"
        const val hasNextPage="hasNextPage"
        const val acountNum="acountNum"
        const val userTimezoneOffsetMinutes="user_timezone_offset_minutes"
        const val value="value"
        const val dbIndex="dbIndex"
        const val isPrintOnlyInCafe="isPrintOnlyInCafe"
        const val isAdditionRequired="isAdditionRequired"
        const val isServiceCall="isServiceCall"
        const val printerLocations="printerLocations"
        const val productAddionId="productAddionId"
        const val checkOutCommandId="checkOutCommandId"
        const val clickCollectLeadDaysCount="ClickCollectLeadDaysCount"
        const val clickCollectOrderMax="ClickCollectOrderMax"
        const val clickCollectOrderMin="ClickCollectOrderMin"
        const val isAlcohol="isAlcohol"
        const val isVegan="isVegan"
        const val isVegetarian="isVegetarian"
        const val properties="properties"
        const val codeMWSt2="codeMWSt2"
        const val codeMWSt="codeMWSt"
        const val unitSellCode: String="unitSellCode"
        const val salesGroupId: String="salesGroupId"
        const val altName="altName"
        const val categoryId="categoryId"
        const val nestedCategoryId="nestedCategoryId"
        const val isEmployeeArticle="isEmployeeArticle"
        const val isNettoForUser="isNettoForUser"
        const val isNetto="isNetto"
        const val price="price"
        const val priceInCafe="priceInCafe"
        const val cashRegisterId: String ="cashRegisterId"
        const val priceLevel="priceLevel"
        const val tseRemoteCashRegisterId: String="tseRemoteCashRegisterId"
        const val deviceType: String="deviceType"
        const val hardwareId="hardwareId"
        const val typeRFID = "typeRFID"
        const val __typename = "__typename"
        const val cancellationPermissions = "cancelationPermissions"
        const val isTimeTracking = "isTimeTracking"
        const val isViewSales = "isViewSales"
        const val isAdmin = "isAdmin"
        const val isDayFinStatements = "isDayFinStatements"
        const val isManager = "isManager"
        const val mod_ver = "mod_ver"
        const val isFinStatements = "isFinStatements"
        const val shortName = "shortName"
        const val id = "id"
        const val name = "name"
        const val code = "code"
        const val position = "position"
        const val password = "password"
        const val printName = "printName"
        const val isActive = "isActive"
        const val url = "url"
        const val street = "street"
        const val postCode = "postCode"
        const val city = "city"
        const val language = "language"
        const val waiterKey="waiterKey"
        const val codeExtern = "codeExtern"
        const val performance = "performance"
        const val timeTrackingId = "timeTrackingId"
        const val isPasswordOnlyForLogin = "isPasswordOnlyForLogin"
        const val shopId = "shopId"
        const val uid = "uid"
        const val key = "key"
        const val to_ = "to"
        const val from = "from"
        const val phone = "phone"
        const val companyName = "companyName"
        const val additionName = "additionName"
        const val vatNumber = "vatNumber"
        const val optional1 = "optional1"
        const val optional2 = "optional2"
        const val autoCloseBill = "autoCloseBill"
        const val advertisingText = "advertisingText"
        const val country = "country"
        const val autoPrintBills = "autoPrintBills"
        const val notPrintRFIDBills = "notPrintRFIDBills"
        const val printBillFromAmount = "printBillFromAmount"
        const val loginMode = "loginMode"
        const val loyaltyProdItemId = "loyaltyProdItemId"
        const val loyaltyProdItemIdOp2 = "loyaltyProdItemIdOp2"
        const val loyaltyProdItemIdOp3 = "loyaltyProdItemIdOp3"
        const val loyaltyProdItemIdOp4 = "loyaltyProdItemIdOp4"
        const val loyaltyProdItemIdOp5 = "loyaltyProdItemIdOp5"
        const val employeeLoyaltyProductId = "employeeLoyaltyProductId"
        const val smsNotificationPhoneNumbers = "smsNotificationPhoneNumbers"
        const val receiptPrintersConfiguration = "receiptPrintersConfiguration"
        const val separateKitchenReports = "separateKitchenReports"
        const val showPriceOnKitchenReport = "showPriceOnKitchenReport"
        const val printNextCoursePositions = "printNextCoursePositions"
        const val eftTerminalType = "eftTerminalType"
        const val eftHSPayTapToPayStoreId = "eftHSPayTapToPayStoreId"
        const val eftHSPayPoiId = "eftHSPayPoiId"
        const val eftHSPayLiveUrl = "eftHSPayLiveUrl"
        const val eftHSPayApiKey = "eftHSPayApiKey"
        const val eftTerminalIp = "eftTerminalIp"
        const val eftTerminalPort = "eftTerminalPort"
        const val eftTerminalTid = "eftTerminalTid"
        const val eftPrintReceipt = "eftPrintReceipt"
        const val eftWalleeKey = "eftWalleeKey"
        const val eftWalleeVirtualTid = "eftWalleeVirtualTid"
        const val eftWalleeUser = "eftWalleeUser"
        const val eftWalleeSpace = "eftWalleeSpace"
        const val eftWalleeTid = "eftWalleeTid"
        const val clientConfigTaxNormalRate = "clientConfigTaxNormalRate"
        const val clientConfigTaxReducedRate = "clientConfigTaxReducedRate"
        const val clientConfigTaxHotelRate = "clientConfigTaxHotelRate"
        const val clientConfigCountry = "clientConfigCountry"
        const val clientConfigLanguage = "clientConfigLanguage"
        const val clientConfigCompanyVatNo = "clientConfigCompanyVatNo"
        const val clientConfigCompanyTitle = "clientConfigCompanyTitle"
        const val clientConfigCompanyName = "clientConfigCompanyName"
        const val clientConfigCompanyAddition = "clientConfigCompanyAddition"
        const val clientConfigCompanyStreet = "clientConfigCompanyStreet"
        const val clientConfigCompanyZIP = "clientConfigCompanyZIP"
        const val clientConfigCompanyCity = "clientConfigCompanyCity"
        const val clientConfigCompanyTelephone = "clientConfigCompanyTelephone"
        const val clientConfigCompanyOptional1 = "clientConfigCompanyOptional1"
        const val clientConfigCompanyOptional2 = "clientConfigCompanyOptional2"


        object VirtualCardFields {
            const val ISSUER_NAME = "issuerName"
            const val ISSUER_EMAIL = "issuerEmail"
            const val PROGRAM_NAME = "programName"
            const val ACCOUNT_ID_LABEL = "accountIdLabel"
            const val REWARDS_TIER_LABEL = "rewardsTierLabel"
            const val REWARDS_TIER = "rewardsTier"
            const val SECONDARY_REWARDS_TIER_LABEL = "secondaryRewardsTierLabel"
            const val SECONDARY_REWARDS_TIER = "secondaryRewardsTier"

            const val PHONE_DESCRIPTION="linkPhoneUri_description"
            const val PHONE_LINK="linkPhoneUri_link"
            const val HOME_PAGE_DESCRIPTION="homepageUri_description"
            const val HOME_PAGE_LINK="homepageUri_link"
        }
    }

    object GqlConsts {
        object Fragments {
            const val CASH_REGISTER_CONFIG_FIELDS = """
                fragment CashRegisterConfigFields on CashRegisterConfig {
                    id
                    modVer
                    appType
                    state
                    hardwareId
                    country  
                    language
                    taxNormalRate  
                    taxReducedRate  
                    taxHotelRate  
                    companyVATNo  
                    companyTitle  
                    companyName  
                    companyAddition  
                    companyStreet  
                    companyZIP  
                    companyCity  
                    companyTelephone  
                    companyOptional1  
                    companyOptional2
                    restaurantDesignId
                    restaurantDefaultRoomId
                    restaurantAvailableRooms {
                        id
                        caption
                    }
                    receiptPrintersConfig {
                        type
                        connectionTarget
                        roomIds
                    }
                    separateKitchenReports
                    showPriceOnKitchenReport
                    printNextCoursePositions
                    kitchenStations {
                        id
                        isActive
                        name
                        type
                        connectionTarget
                        kdsSN
                        waiterCopy
                        tableShiftReceipt
                        isAnnounce
                        roomIds
                    }
                    availableKds {
                        sn
                        name
                    }
                    availablePrinters {
                        sn
                        name
                    }
                    hsPayStores {
                        id
                        name
                    }
                    eftConfig {
                        type
                        ip
                        port
                        tid
                        hsPayStoreId
                        hsPayPoiId
                        hsPayUrl
                        hsPayApiKey
                        printEftReceipt
                        walleeKey
                        walleeVirtualTid
                        walleeUser
                        walleeSpace
                        walleeTid
                    }
                    
                }
            """
        }
    }
}